import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IRecalculateCollectionCountsV1Response } from './recalculate-collection-counts-v1-response';
import { recalculateCollectionCountsV1ResponseSchema } from './recalculate-collection-counts-v1-response';

export async function recalculateCollectionCountsV1Api(): Promise<
  IValidatedResponse<IRecalculateCollectionCountsV1Response>
> {
  return postRequest<IRecalculateCollectionCountsV1Response>({
    path: '/sys/collections/v1/recalculate-counts',
    schema: recalculateCollectionCountsV1ResponseSchema,
  });
}
